// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c89920d8","513":"dd700dbf","545":"3ea7a286","787":"79265a88"}[chunkId] + ".chunk.js";
};